import React from 'react'

const React_Coding_Practice_34 = () => {
  return (
    <div>
      <h1>Coding Pratice 34</h1>
    </div>
  )
}

export default React_Coding_Practice_34
